import { PopulationTypes } from './types.js';
export const PopulationTypeLabelMap = {
    general: 'General',
    specific: 'Specific',
};
const Metadata_PopulationType = {
    optional: false,
    description: `Type of the population (${[...PopulationTypes].join(' / ')})`,
    valueType: 'string',
};
export const Metadata_Population = {
    type: { ...Metadata_PopulationType },
    specifications: {
        optional: true,
        description: 'Specifications for the population if the type is specific',
        valueType: 'object',
        metadata: {}
    }
};
//# sourceMappingURL=consts.js.map